<script>
import options from './CaseCarousel.options'
export default options
</script>

<template>
  <article class="kb-case-carousel">
    <!-- hvis det er kun er ét card - hvis et kort -->
    <template v-if="contentJson.length === 1">
      <section class="kb-case-carousel__single-card-section">
        <div class="kb-case-carousel__header">
          <div class="kb-case-carousel__header-breaker">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 704 11"
            >
              <path stroke="#124999" d="M704 1H2c-.55228 0-1 .44772-1 1v9" />
            </svg>
          </div>
          <h4 class="kb-case-carousel__header-title">
            {{ getLabel('title') }}
          </h4>
        </div>

        <div class="kb-case-carousel__single-card-container">
          <template v-for="(card, index) in contentJson">
            <CaseCard :data="card" />
          </template>
        </div>
      </section>
    </template>

    <!-- hvis der er mere end ét CaseCard vis ContentCarousel -->
    <template v-else-if="contentJson.length > 1">
      <section class="kb-case-carousel__slider">
        <div class="kb-case-carousel__header kb-case-carousel__slider-header">
          <div class="kb-case-carousel__header-breaker">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 704 11"
            >
              <path stroke="#124999" d="M704 1H2c-.55228 0-1 .44772-1 1v9" />
            </svg>
          </div>
          <h4
            class="kb-case-carousel__header-title kb-case-carousel__slider-header-title"
          >
            {{ getLabel('title') }}
          </h4>
        </div>

        <ContentCarousel
          :contentJson="contentJson"
          :link="link"
          :type="type"
          :carouselId="carouselId"
        />
      </section>
    </template>
  </article>
</template>
